// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1qJBN","content":"styles_content__BYuTb","tableWrap":"styles_tableWrap__2HwEY"};